import { PercentProps } from 'components/shared/Percent/model';
import { PercentWithUnit } from 'components/shared/Percent/PercentWithUnit';
import { ILockBtnProps, LockBtn } from 'components/shared/WithLock/LockBtn';
import { WithUnitProps } from 'components/shared/WithUnit/WithUnit';

export type PercentWithUnitAndLockProps = PercentProps & WithUnitProps & ILockBtnProps;

export const PercentWithUnitAndLock = (props: PercentWithUnitAndLockProps) => {
  const {
    id,
    isLocked,
    isDisabled,
    isLoading,
    onLockChanged,
    tabIndex,
    className,
    isCellInactive,
    isDelegated,
    ...percentProps
  } = props;
  return (
    <PercentWithUnit
      {...percentProps}
      isDisabled={isLocked || isDisabled || isLoading}
      id={id}
      tabIndex={tabIndex ? tabIndex + 1 : undefined}
      className={className}
      isCellInactive={isCellInactive}
    >
      <LockBtn
        e2e={props.e2e}
        isLocked={isLocked}
        onLockChanged={onLockChanged}
        isDisabled={isDisabled}
        isLoading={isLoading}
        tabIndex={tabIndex}
        isDelegated={isDelegated}
      />
    </PercentWithUnit>
  );
};
